module.exports = __webpack_public_path__ + "static/media/icon_1.ea2a9848.svg";